import type React from "react";

import ImgTrendNegativeChart from "@/assets/images/analytics/trend-negative-chart.svg";
import ImgTrendNeutralChart from "@/assets/images/analytics/trend-neutral-chart.svg";
import ImgTrendPositiveChart from "@/assets/images/analytics/trend-positive-chart.svg";

interface AnalyticsTrendGraphicProps {
  value: number;
  referenceValue?: number;
  isTrendInversed?: boolean;
}

export function AnalyticsTrendGraphic({
  value,
  referenceValue,
  isTrendInversed,
}: AnalyticsTrendGraphicProps): React.ReactNode {
  let variant: "positive" | "negative" | "neutral" = "neutral";

  if (referenceValue !== undefined) {
    if (value > referenceValue) {
      variant = isTrendInversed ? "negative" : "positive";
    } else if (value < referenceValue) {
      variant = isTrendInversed ? "positive" : "negative";
    }
  }

  return (
    <figure className="aspect-video w-full max-w-thumbnail-compact">
      {variant === "positive" && <img className="size-full" src={ImgTrendPositiveChart} alt="Positive trend graphic" />}
      {variant === "negative" && <img className="size-full" src={ImgTrendNegativeChart} alt="Negative trend graphic" />}
      {variant === "neutral" && <img className="size-full" src={ImgTrendNeutralChart} alt="Neutral trend graphic" />}
    </figure>
  );
}
